import { render } from "./Credits.vue?vue&type=template&id=6f67137b&scoped=true"
import script from "./Credits.vue?vue&type=script&lang=js"
export * from "./Credits.vue?vue&type=script&lang=js"

import "./Credits.vue?vue&type=style&index=0&id=6f67137b&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-6f67137b"

export default script